export default __webpack_public_path__ + "static/media/contemporary-desktop.6bfd0dbe.jpg";